// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#idSearch {
  display: flex;
}
.search {
  display: flex;
  height: 25px;
}

.search.replace-active {
  height: 55px;
}

.search-btn {
  margin: auto;
  margin-right: 2px;
}

.search-btn button {
  height: 26px;
}

.search-btn button.replace-active {
  height: 54px;
}

.search-form,
.replace-form {
  display: flex;
}

.search-result {
  margin: auto 5px;
}

#idSearch .tooltip-wrapper {
  margin: auto 2px !important;
}

.replace-form {
  margin-top: 2px;
}

.search input {
  height: 20px;
  margin-right: 5px;
}

.search p {
  margin: 0;
}

.search button img {
  vertical-align: sub;
}

.search button svg {
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/transcript/components/search/search.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":["#idSearch {\n  display: flex;\n}\n.search {\n  display: flex;\n  height: 25px;\n}\n\n.search.replace-active {\n  height: 55px;\n}\n\n.search-btn {\n  margin: auto;\n  margin-right: 2px;\n}\n\n.search-btn button {\n  height: 26px;\n}\n\n.search-btn button.replace-active {\n  height: 54px;\n}\n\n.search-form,\n.replace-form {\n  display: flex;\n}\n\n.search-result {\n  margin: auto 5px;\n}\n\n#idSearch .tooltip-wrapper {\n  margin: auto 2px !important;\n}\n\n.replace-form {\n  margin-top: 2px;\n}\n\n.search input {\n  height: 20px;\n  margin-right: 5px;\n}\n\n.search p {\n  margin: 0;\n}\n\n.search button img {\n  vertical-align: sub;\n}\n\n.search button svg {\n  height: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
